<template>
  <div class="cursor-pointer" v-if="flightItemLength">
    <ul
      class="
        flex flex-nowrap
        min-w-17rem
        h-2.5rem
        text-sm
        leading-10
        justify-between
        border
        bg-white
        px-2
        rounded
        truncate
      "
      :class="{ select_ul: isActive }"
      @click="showMore"
      v-if="showItem"
    >
      <li class="">{{ showItem.deparea.name }}-{{ showItem.desarea.name }}</li>
      <li class="whitespace-pre-wrap leading-snug text-center">
        <span class="block">{{ showItem.number }}</span>
        <span class="text-xs whitespace-nowrap">
          {{ showItem.arrtime.timestamp | timeFormat }}-{{
            showItem.deptime.timestamp | timeFormat
          }}
        </span>
      </li>
      <li class="">
        {{ showItem.date.timestamp | dateFormat }}
      </li>
      <li class="text-gray-400">
        <i
          class="el-icon-arrow-down select_icon"
          :class="{ select_icons: isActive }"
        ></i>
      </li>
    </ul>
    <ul
      class="
        flex flex-nowrap
        justify-between
        text-gray-400
        border
        bg-white
        px-4
        rounded
        w-17rem
        h-2.5rem
        leading-9
        text-sm
      "
      @click="showMore"
      :class="{ select_ul: isActive }"
      v-else
    >
      <li class="space-x-3">
        <span class=""></span>
        <span>{{ $t("请选择航班") }}</span>
      </li>

      <li class="text-gray-400">
        <i
          class="el-icon-arrow-down select_icon"
          :class="{ select_icons: isActive }"
        ></i>
      </li>
    </ul>
    <div
      :class="{ active: isActive }"
      class="mt-2 z-999 absolute rounded border bg-white hidden"
    >
      <ul
        class="
          flex flex-nowrap
          w-17rem
          h-2.5rem
          text-sm
          whitespace-nowrap
          leading-10
          justify-between
          px-2
          hover:bg-gray-50
          mt-2
        "
        @click="changeMore(item)"
        v-for="item in flightItem"
        :key="item.index"
      >
        <li class="">{{ item.deparea.name }}-{{ item.desarea.name }}</li>
        <li class="whitespace-pre-wrap leading-snug">
          <span class="block">{{ item.number }}</span>
          <span class="text-xs">
            {{ item.arrtime.timestamp | timeFormat }}-{{
              item.deptime.timestamp | timeFormat
            }}
          </span>
        </li>
        <li>{{ item.date.timestamp | dateFormat }}</li>
      </ul>
    </div>
  </div>

  <div
    v-else
    class="
      text-gray-400
      border
      bg-white
      px-2
      rounded
      w-17rem
      h-2.5rem
      leading-9
      text-sm
    "
  >
    {{ $t("暂无航班") }}
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";

import dayjs from "@/API/util/dayjs.js";

export default {
  props: {
    showItem: Object,
    flightItem: Array,
    flightItemLength: Number || String,
  },
  filters: {
    timeFormat: function (value, spe) {
      const _time = dayjs.unix(value).format("HH:mm");
      return _time;
    },
    dateFormat: function (value, spe) {
      const _date = dayjs.unix(value).format("MM-DD");
      return _date;
    },
  },
  setup(props, ctx) {
    const isActive = ref(false);
    const showMore = () => {
      isActive.value = !isActive.value;
    };
    const changeMore = (item) => {
      isActive.value = !isActive.value;
      ctx.emit("changeMore", item);
    };

    return { showMore, isActive, changeMore };
  },
};
</script>
<style scoped>.active {
  display: block;
}
.select_icon {
  transition: all 0.5s;
}
.select_icons {
  transform: rotate(-180deg);
}
.select_ul {
  --tw-border-opacity: 1;
  border-color: rgba(16, 185, 129, var(--tw-border-opacity));
}</style>
